import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PermissionAccessDirective } from './permission-access.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [PermissionAccessDirective],
  exports: [PermissionAccessDirective],
})
export class PermissionAccessModule {}
